module.exports = __webpack_public_path__ + "static/media/20.598c60a7.jpg";